<template>
    <div class="users box">
        <h2>{{ t('places-users-title') }}</h2>
        <user-form ref="userForm" />
        <table class="table table--list">
            <thead>
                <tr>
                    <th>{{ t('name') }}</th>
                    <th>{{ t('email') }}</th>
                    <th>{{ t('username') }}</th>
                    <th>{{ t('places-users-active') }}</th>
                    <th>{{ t('actions') }}</th>
                    <th>{{ t('two_factor_auth') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(user, index) in users" :key="index">
                    <td>{{ user.name }}</td>
                    <td>{{ user.email }}</td>
                    <td>{{ user.username }}</td>
                    <td>{{ user.active === "1" ? t('yes') : t('no') }}</td>
                    <td>
                        <button
                            class="bnt btn-primary"
                            @click="editUser(user.id)"
                        >
                            <i class="fa fa-pencil"></i>
                        </button>
                    </td>
                    <td>{{ (user.twofa_enabled || user.twofa_token) ? t('yes') : t('no') }}</td>
                </tr>
            </tbody>
        </table>
        <button class="btn btn-primary pull-right" @click="addUser">
            {{ t('places-users-add_user') }}
        </button>
        <div class="clear"></div>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import UserForm from "./form";
export default {
    components: {
        UserForm,
    },
    computed: mapState({
        users: (state) => state.placeDetails.users,
        branches: (state) => state.placeDetails.branches,
    }),
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        ...mapActions({
            addUser: "placeDetails/addUser",
            editUser: "placeDetails/editUser",
        }),
    },
};
</script>
